import { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Stack,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchIcon from '@mui/icons-material/Search';

const SubscriptionInvoices = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  const invoices = [
    {
      id: 12,
      company: 'South Texas Aggr...',
      period: '12-01-2024 - 01-01',
      status: 'Paid',
      date: '12-01-2024',
      balance: '$0.00',
    },
    {
      id: 11,
      company: 'South Texas Aggr...',
      period: '11-01-2024 - 12-01',
      status: 'Paid',
      date: '11-01-2024',
      balance: '$0.00',
    },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant='h5' sx={{ mb: 3, color: '#111827' }}>
        Subscription Invoices
      </Typography>

      <Box sx={{ mb: 3, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ width: '100%' }}>
            <DatePicker
              label='From'
              value={startDate}
              onChange={(date) => setStartDate(date)}
              slotProps={{ textField: { fullWidth: true } }}
              sx={{ flexGrow: 1 }}
            />
            <DatePicker
              label='To'
              value={endDate}
              onChange={(date) => setEndDate(date)}
              slotProps={{ textField: { fullWidth: true } }}
              sx={{ flexGrow: 1 }}
            />
            <Box sx={{ display: 'flex', gap: 1, flexGrow: 1 }}>
              <TextField
                fullWidth
                placeholder='Search by invoice #'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                sx={{ flexGrow: 1 }}
              />
              <Button
                variant='contained'
                startIcon={<SearchIcon />}
                sx={{
                  bgcolor: '#111827',
                  '&:hover': {
                    bgcolor: '#1f2937',
                  },
                }}
              >
                Search
              </Button>
            </Box>
          </Stack>
        </LocalizationProvider>
      </Box>

      <TableContainer component={Paper} sx={{ boxShadow: 1 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: '#f3f4f6' }}>
              <TableCell>Invoice #</TableCell>
              <TableCell>Company</TableCell>
              <TableCell>Period</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Balance</TableCell>
              <TableCell align='center'>View</TableCell>
              <TableCell align='center'>Download</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.map((invoice) => (
              <TableRow key={invoice.id} sx={{ '&:hover': { bgcolor: '#f9fafb' } }}>
                <TableCell>{invoice.id}</TableCell>
                <TableCell>{invoice.company}</TableCell>
                <TableCell>{invoice.period}</TableCell>
                <TableCell>
                  <Box
                    sx={{
                      bgcolor: invoice.status === 'Paid' ? '#dcfce7' : '#fee2e2',
                      color: invoice.status === 'Paid' ? '#166534' : '#991b1b',
                      py: 0.5,
                      px: 2,
                      borderRadius: 1,
                      display: 'inline-block',
                    }}
                  >
                    {invoice.status}
                  </Box>
                </TableCell>
                <TableCell>{invoice.date}</TableCell>
                <TableCell>{invoice.balance}</TableCell>
                <TableCell align='center'>
                  <IconButton size='small' sx={{ color: '#111827' }}>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
                <TableCell align='center'>
                  <IconButton size='small' sx={{ color: '#111827' }}>
                    <FileDownloadIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SubscriptionInvoices;
